import { API } from "../../main.js";

const state = {
  cluster: {
    maxPathwayDistance:
      localStorage.getItem("cluster_max_pathway_distance") || 0,
    maxCableLength:
      localStorage.getItem("cluster_max_cable_length") || undefined
  },
  clusterClosures: {},
  clusterToolForm: false
};

const getters = {
  getClusterMaxPathwayDistance: state => state.cluster.maxPathwayDistance,
  getClusterMaxCableLength: state => state.cluster.maxCableLength,
  getClusterToolForm: state => state.clusterToolForm,
  getClusterToolData: state => state.clusterClosures
};

const mutations = {
  SET_CLUSTER_MAX_PATHWAY_DISTANCE(state, data) {
    state.cluster.maxPathwayDistance = data;
    localStorage.setItem("cluster_max_pathway_distance", data);
  },
  SET_CLUSTER_MAX_CABLE_LENGTH(state, data) {
    state.cluster.maxCableLength = data;
    localStorage.setItem("cluster_max_cable_length", data);
  },
  //Sends data to cable form component to be saved along with cable information
  SET_CLUSTER_TOOL_DATA_TO_SEND(state, data) {
    state.clusterClosures = data;
  },
  //tells cable component when saving if its to save for the cluster tool, else creates a normal cable
  SET_CLUSTER_TOOL_FORM(state, data) {
    state.clusterToolForm = data;
  }
};

const actions = {
  setClusterToolData({ commit }, data) {
    commit("SET_CLUSTER_TOOL_DATA_TO_SEND", data);
  },

  GET_CLUSTER_OBJECTS({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.cluster.getObjects(
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error.response.data);
        }
      );
    });
  },

  CREATE_CLUSTER({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.cluster.create(
        data,
        result => {
          commit("SET_CLUSTER_MAX_PATHWAY_DISTANCE", data.max_pathway_distance);
          commit("SET_CLUSTER_MAX_CABLE_LENGTH", data.max_cable_length);
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  // Creates preview of cables after selected closure
  CLUSTER_TOOL_PREVIEW({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.cluster.clusterToolPreview(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  //creates new cables after the selection of closures is done
  CLUSTER_TOOL_CREATE({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.cluster.clusterToolCreate(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  callRedrawCluster({ commit }, data){
    return new Promise((resolve, reject) => {
      API.cluster.redrawCluster(
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/cluster.js